import React from "react";
import { CookiesProvider } from "react-cookie";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { SessionProvider } from "./components/session/Context";
import "./css/index.scss";
import "./css/style.scss";
import "./css/mashup.scss";
import "react-toastify/dist/ReactToastify.css";
import { Landing } from "./components/Landing";
import { ToastContainer } from "react-toastify";
import { MyProvider } from "./MyContext";

function App() {
  return (
    <CookiesProvider>
      <BrowserRouter>
        <SessionProvider cookie_name="issuer_session">
          <ToastContainer />
          <MyProvider>
            <Landing />
          </MyProvider>
        </SessionProvider>
      </BrowserRouter>
    </CookiesProvider>
  );
}

export default App;
